import { color } from 'd3-color';

export function isLightColor(value: string) {
  const c = color(value);

  if (!c) {
    return false;
  }

  const { r, g, b } = c.rgb();
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  return brightness >= 128;
}
